import React from 'react';
import { Link, LinkProps } from "react-router-dom";

export interface BaseLinkProps extends LinkProps {
    model: string;
}
  
export const BaseLink: React.FC<BaseLinkProps> = (props) => (
  <Link {...props}>
    {props.children}
  </Link>
);
